import { render, staticRenderFns } from "./riOutward.vue?vue&type=template&id=aff63774&"
import script from "./riOutward.vue?vue&type=script&lang=js&"
export * from "./riOutward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports